import type { ISupervisionGetOne } from '../../interfaces/supervisionGetOne';
import type { ITask } from '../../interfaces/task';
import { SupervisionStatus } from '../../../../common/enums/supervisionStatus';
import { TaskType } from '../../../../common/enums/task';
import { translateKey } from '../../../translate';
import { Button } from '../common';

interface IEditSupervisionButtonProps {
    editSupervision: () => Promise<void>;
    practitionerId: string;
    supervision?: ISupervisionGetOne;
    task?: ITask;
}

export function EditSupervisionButton(props: IEditSupervisionButtonProps) {
    if (
        !props.task ||
        !props.supervision ||
        !props.supervision.authorization ||
        !props.supervision.authorization.canUpdateSupervision ||
        props.task.performerOrganizationId !== props.supervision.performerOrganizationId ||
        props.task.type !== TaskType.supervise ||
        props.supervision.status !== SupervisionStatus.draft ||
        props.practitionerId !== props.task.performerPractitionerId
    ) {
        return null;
    }

    return (
        <Button
            automation="editSupervision"
            color="secondary"
            large
            onClick={props.editSupervision}
        >
            {translateKey('supervision.edit')}
        </Button>
    );
}
